import type { UserDto } from '@issuemanager/api-client';
import {
  UserMultipleSelectorField,
  type UserMultipleSelectorFieldProps,
} from '@issuemanager/apps/client/components';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

export type TypeManagersSelectorProps = UserMultipleSelectorFieldProps<UserDto>;

export function TypeManagersSelector(
  props: TypeManagersSelectorProps,
): JSX.Element | null {
  const { t } = useTranslation('settings');

  return (
    <UserMultipleSelectorField<UserDto>
      placeholder={t('issueTypes.form.issueType.placeholder.issueTypeManagers')}
      data-testid='issue-managers'
      getTestIdOption={(option) => option.name}
      {...props}
    />
  );
}
